<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 18 18"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path clip-rule="evenodd" d="M3.375 0H14.625C16.489 0 18 1.51104 18 3.375V14.625C18 16.489 16.489 18 14.625 18H3.375C1.51104 18 0 16.489 0 14.625V3.375C0 1.51104 1.51104 0 3.375 0ZM3.375 1.125C2.13236 1.125 1.125 2.13236 1.125 3.375V14.625C1.125 15.8676 2.13236 16.875 3.375 16.875H14.625C15.8676 16.875 16.875 15.8676 16.875 14.625V3.375C16.875 2.13236 15.8676 1.125 14.625 1.125H3.375Z" :fill="fill" fill-rule="evenodd"/>
    <path clip-rule="evenodd" d="M13.4435 4C13.7509 4 14 4.24914 14 4.55647V4.55713V4.5578V10.1198C14 10.4278 13.7503 10.6776 13.4422 10.6776C13.1341 10.6776 12.8844 10.4279 12.8844 10.1198V5.92389L4.95223 13.837C4.7344 14.0543 4.38121 14.0543 4.16338 13.837C3.94554 13.6197 3.94554 13.2674 4.16338 13.0501L12.1196 5.11293L7.86282 5.11293C7.55549 5.11293 7.30635 4.86379 7.30635 4.55647C7.30635 4.24914 7.55549 4 7.86282 4H13.4422H13.4435Z" :fill="fill" fill-rule="evenodd"/>
  </svg>

</template>

<script>
export default {
  name: 'LinkArrow',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
